import { render, staticRenderFns } from "./TemplateElegant.vue?vue&type=template&id=4f1e5cee&"
import script from "./TemplateElegant.vue?vue&type=script&lang=js&"
export * from "./TemplateElegant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports